/**
 * Cart Controller
 */
angular.module('bookingApp')
    .controller('cartController', function($scope, $http){

    // proceeed to cart control checking
    $scope.proceedToLeadGuest = false;
    $scope.extrasErrors = false;
    $scope.checkSelectedRoomsAreAvailable();
    $scope.baseApp.controls.type = 'back';
    $scope.editRoom = editRoom;
   // extra editing functionality
    $scope.editRoomExtra = editRoomExtra;
    $scope.removeRoomExtra = removeRoomExtra;
    // -- booking level extras
    $scope.editBookingExtra = editBookingExtra;
    $scope.removeBookingExtra = removeBookingExtra;
    // add extras actions
    $scope.addRoomExtras = addRoomExtras;
    $scope.addBookingExtras = addBookingExtras;

    $scope.extraShouldBeExcludedFromRoom = extraShouldBeExcludedFromRoom;
    $scope.extraShouldBeExcludedFromBooking = extraShouldBeExcludedFromBooking;

    $scope.checkExtras = checkExtras;
    $scope.showAddAnotherExtra = showAddAnotherExtra;

    if($scope.property.addressProviderScript){
        $scope.loadExternalScript($scope.property.addressProviderScript);
    }

        // setup footer controls
    if($scope.property.isItemOnly){
        $scope.$watch('cart.bookingExtras.selected', setupItemOnlyFooterFunctionality);
    } else {
        $scope.$watch('cart.rooms.length', setupFooterFunctionality, true);
    }
    // watch for errors in the cart and adjust the proceed to lead guest button accordingly
    $scope.$watch('cart.hasErrors', checkCartHasErrors);
    $scope.$watch('extrasErrors', checkExtraErrors);
    // watch for change in room and update room total
    $scope.$watch('$scope.cart.rooms', checkCartRoomTotal,true);

    $scope.roomGroupShown = [];
    $scope.showOnRoomGroup = function(roomGroupIndex){
        if($scope.roomGroupShown.indexOf(roomGroupIndex) === -1){
            $scope.roomGroupShown.push(roomGroupIndex);
            return true;
        } else {
            return false;
        }
    };
    //
    //  $scope.getGroupAdults = function(roomGroupIndex){
    //     return $scope.getPaxGroupCount('adults', roomGroupIndex);
    // };
    //
    // $scope.getGroupChildren = function(roomGroupIndex){
    //     return $scope.getPaxGroupCount('children', roomGroupIndex);
    // };
    //
    // $scope.getGroupInfants = function(roomGroupIndex){
    //     return $scope.getPaxGroupCount('infants', roomGroupIndex);
    // };
    //
    // $scope.getPaxGroupCount = function(paxType, roomGroupIndex){
    //     var count = 0;
    //     angular.forEach(cart.rooms, function(room){
    //         if(room.roomGroupIndex === roomGroupIndex){
    //             switch(paxType){
    //                 case 'adults':
    //                     count += room.paxConfig.adults;
    //                     break;
    //                 case 'children':
    //                     count += room.paxConfig.children;
    //                     break;
    //                 case 'infants':
    //                     count += room.paxConfig.infants;
    //                     break;
    //             }
    //         }
    //     });
    //     return count;
    // };


    function setupFooterFunctionality(newVal, oldVal){
        if($scope.cart.rooms.length <= 0){
            // hide the controls and show back button
            $scope.footer.display.prev = false;
            $scope.footer.display.next = false;
            $scope.proceedToLeadGuest = false;
            $scope.footer.disabled.next = true;
            $scope.footer.mainContent = '<span class="glyphicon glyphicon-chevron-left"></span> Back';
            $scope.footer.mainFunc = goToRooms;
            $scope.safeApply();
        } else {
            $scope.setupStandardCartFooter();
            $scope.proceedToLeadGuest = true;
            $scope.footer.nextFunc = goToLeadGuest;
            $scope.safeApply();
        }
    }

    function showAddAnotherExtra(){
        var shouldShow = ($scope.property.isMultiProp && (Array.isArray($scope.extras.extras) && (!$scope.extras.extras.length > 0)));
        return shouldShow;
    }
        
    function setupItemOnlyFooterFunctionality(newVal, oldVal){
        if($scope.cart.bookingExtras.selected.length <= 0){
            // hide the controls
            $scope.footer.display.prev = false;
            $scope.footer.display.next = false;
            $scope.footer.mainContent = '<span class="glyphicon glyphicon-chevron-left"></span> Back';
            $scope.footer.mainFunc = function(){
                $scope.goBack();
            };
            $scope.safeApply();
        } else {
            $scope.setupItemOnlyFooter();
            $scope.footer.disabled.next = false;
            $scope.proceedToLeadGuest = true;
            $scope.footer.nextFunc = function(){
                $scope.goToPage('lead-guest');
            };
            $scope.safeApply();
        }
    }

    function checkCartHasErrors(newVal){
        if(newVal){
            $scope.proceedToLeadGuest = false;
        } else {
            if($scope.cart.rooms.length <= 0 && !$scope.property.isItemOnly) {
                $scope.proceedToLeadGuest = false;
                $scope.footer.disabled.next = true;
            } else {
                if($scope.property.isItemOnly && $scope.cart.bookingExtras.selected.length <= 0){
                    $scope.proceedToLeadGuest = false;
                } else {
                    $scope.proceedToLeadGuest = true;
                }
            }
        }
    }

    function checkExtraErrors(newVal, oldVal){
        if(newVal){
            $scope.footer.nextFunc = function(){
                if(typeof $('.extra-error').not('.ng-hide').position() !== 'undefined')
                {
                    if(typeof $('.extra-error').not('.ng-hide').position().top !== 'undefined') {
                        var errorY = $('.extra-error').not('ng-hide').position().top;
                        $('html, body').stop().animate({scrollTop: (errorY - 150)});
                    }
                }
            }
        } else {
            if($scope.proceedToLeadGuest) {
                $scope.footer.nextFunc = function(){
                    // proceed to booking summary
                    $scope.goToPage('lead-guest');
                };
            }
        }
    }

    function checkCartRoomTotal(){
        $scope.getCartRoomTotal();
    }


    function goToRooms(){
        $scope.goToRooms();
    }

    function goToLeadGuest(){
        // proceed to booking summary
        $scope.goToPage('lead-guest');
    }

    function editRoom(room){
        // redirect the user to the edit room functionality
        var page = 'cart/edit/room/'+room;
        $scope.goToPage(page);
    }

    function editRoomExtra(room, extra){
        var page = 'cart/edit/extra/'+room+'/'+extra;
        $scope.goToPage(page);
    }

    function removeRoomExtra(roomIndex, extraIndex){
        $scope.cart.rooms[roomIndex].selectedExtras.splice(extraIndex, 1);
        $scope.extrasErrors = $scope.checkExtras();
        $scope.checkSelectedRoomsAreAvailable();
        // if there are no rooms left, then remove any madatory extras...
    }
    function editBookingExtra(extra){
        var page = 'cart/edit/extra/'+extra;
        $scope.goToPage(page);
    }
    function removeBookingExtra(extraIndex){
        $scope.cart.bookingExtras.selected.splice(extraIndex, 1);
        $scope.extrasErrors = $scope.checkExtras();
        if($scope.property.isItemOnly && $scope.cart.bookingExtras.selected.length === 0){
            $scope.proceedToLeadGuest = false;
            $scope.footer.disabled.next = true;
        }
        if($scope.property.isItemOnly){
            $scope.setupItemOnlyFooter();
        }
        $scope.safeApply();
        // refresh booking on server
        $scope.checkSelectedRoomsAreAvailable();
    }
    function addRoomExtras(room){
        var page = 'extras/room/'+room;
        $scope.goToPage(page);
    }

    function addBookingExtras(){
        var page = 'extras';
        $scope.goToPage(page);
    }

    function extraShouldBeExcludedFromRoom(room, extra){
        var excludeExtra = false;
        // set cart.hasErrors to true if this doesn't match up with anything.
        for(var exRate in extra.extra.excludedRates){
            if(extra.extra.excludedRates.hasOwnProperty(exRate)){
                if(exRate === room.roomDetails.rate.id){
                    $scope.extrasErrors = true;
                    excludeExtra = true;
                }
            }
        }
        return excludeExtra;
    }

    function extraShouldBeExcludedFromBooking(extra){
        var usedRates = $scope.cart.getUsedRates();
        // check the excluded rates on the extra
        for(exRate in extra.extra.excludedRates){
            if(extra.extra.excludedRates.hasOwnProperty(exRate)){
                if(usedRates.indexOf(extra.extra.excludedRates[exRate].id) >= 0){
                    $scope.extrasErrors = true;
                    return true;
                }
            }
        }
        return false;
    }

    function checkExtras(){
        var errorsFound = false;
        for(var room in $scope.cart.rooms){
            if($scope.cart.rooms.hasOwnProperty(room)){
                for(var extra in $scope.cart.rooms[room].selectedExtras){
                    if($scope.cart.rooms[room].selectedExtras.hasOwnProperty(extra)){
                        if($scope.extraShouldBeExcludedFromRoom(room, $scope.cart.rooms[room].selectedExtras[extra])){
                            errorsFound = true;
                        }
                    }
                }
            }
        }
        for(var extra in $scope.cart.bookingExtras.selected){
            if($scope.cart.bookingExtras.selected.hasOwnProperty(extra)){
                if($scope.extraShouldBeExcludedFromBooking($scope.cart.bookingExtras.selected[extra])){
                    errorsFound = true;
                }
            }
        }
        return errorsFound;
    }
});